export default {
    // 上半部分
    assurance1: "1小時快速響應",
    assurance2: "7天無條件退貨",
    assurance3: "15天免費退貨",
    assurance4: "批量採購優惠",
    assurance5: "全澳門發貨",
    help: "幫助中心",
    serve: "服務支持",
    store: "線下門店",
    join: "店鋪加盟",
    time: "週一至週日 8:00-18:00",
    only: "（僅收市話費）",
    online: "24小時在線客服",
    // 下半部分
    friendly: "友情鏈接：",
    cooperate: "合作夥伴：",
    copyright: "Copyright 2018 www.advance-stationery.com. All Rights Reserved.版權所有：香港進思文具有限公司",
	// copyright: "Copyright 2018 www.blossom-power.com. All Rights Reserved.版權所有：堡城動力",
    word: "不一樣的服務體驗"
	// word: ""
}